// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store/index'
import elementUI from 'element-ui'
import elementLocale from 'element-ui/lib/locale'
import 'element-ui/lib/theme-chalk/index.css'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import './styles/common.scss'
import router from './router'
import { getToken } from '@/utils/auth'
import { sysGetToken } from '@/utils/sys_auth'
import plupload from 'plupload'
import * as Lodash from 'lodash'
import VueI18n from 'vue-i18n'
// language
import localLanguage from './i18n'

import { getLoginInfoByToken } from '@/api/management/v2/login'
import { getUrlParams, versioncodeFormat } from '@/utils/index'

// 下拉加载更多组件
import InfiniteScroll from '@/components/infinite-scroll/index.js'
import elTableInfiniteScroll from '@/components/el-table-infinite-scroll/index.js'

Vue.use(VueI18n)
Vue.use(elementUI)
Vue.use(plupload)
Vue.use(InfiniteScroll)
Vue.use(elTableInfiniteScroll)

Vue.prototype._Lodash = Lodash
Stimulsoft.Base.StiLicense.loadFromFile('/static/stimulsoft/license.key')
Stimulsoft.Base.Localization.StiLocalization.addLocalizationFile('/static/Localization/zh-CHS.xml', false, 'zh-CHS')
Stimulsoft.Base.Localization.StiLocalization.cultureName = 'zh-CHS'

// 关闭vue tips
Vue.config.productionTip = false
if (location.href.indexOf('token') !== -1) {
  // 检查地址栏是否有token
  let token = getUrlParams('token')
  if (token) {
    let params = {
      token: token
    }
    getLoginInfoByToken(params).then(res => {
      if (res.code !== 20000) {
        return
      }
      localStorage.setItem(
        'manageLoginInfo',
        JSON.stringify({
          token: res.data.token,
          appType: res.data.appType,
          companyCode: res.data.companyCode,
          name: res.data.name,
          account: res.data.account,
          bigVersionNo: versioncodeFormat(res.data.bigVersionNo)
        })
      )
      localStorage.setItem(
        'loginRemindDto',
        JSON.stringify(res.data.loginRemindDto || {})
      )
    })
  }
}
setTimeout(() => {
  router.beforeEach((to, from, next) => {
    NProgress.start()
    // 是否有token
    if (getToken() && to.path.indexOf('management') > -1) {
      if (store.state.Management.name) {
        if (to.path === '/management/login') {
          return next({ path: '/management/index' })
        } else {
          next()
        }
      } else {
        next()
      }
    } else if (sysGetToken() && to.path.indexOf('operation') > -1) {
      if (to.path === '/operation/login') {
        next({ path: '/operation/index' })
      } else {
        next()
      }
    } else {
      // 未登录——跳转登录页
      if (to.path === '/management/login' || to.path === '/operation/login') {
        next()
      } else if (to.path.indexOf('management') > -1) {
        next({ path: '/management/login' })
      } else if (to.path.indexOf('operation') > -1) {
        next({ path: '/operation/login' })
      } else if (to.path === '/') {
        next()
      } else {
        next()
      }
    }
  })
  router.afterEach(() => {
    NProgress.done()
  })
}, 0)

// 设置语言
let locale = 'zh-cn'
let lang = window.localStorage.getItem('LOCALE_KEY')
if (lang) {
  locale = lang
} else {
  let jslang = (navigator.language || navigator.browserLanguage || 'zh-cn').toLowerCase()
  if (jslang.substr(0, 2) === 'zh') {
    locale = jslang === 'zh-cn' ? 'zh-cn' : 'zh-hant'
  } else if (jslang.substr(0, 2) === 'en') {
    locale = 'en'
  } else {
    locale = 'zh-cn'
  }
  window.localStorage.setItem('LOCALE_KEY', locale)
}
store.commit('SET_LANGUAGE_CHANGE', locale)

const i18n = new VueI18n({
  locale: locale || 'zh-cn',
  fallbackLocale: 'zh-cn',
  messages: localLanguage
})
// element I18n
elementLocale.i18n((key, value) => i18n.t(key, value))

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js